import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  campaignDataTablePagination: {
    campaignPageNumber: 1,
  },
};

export const paginationSlice = createSlice({
  name: "campaign_pagination_slice",
  initialState,
  reducers: {
    setCampaignDataTablePagination: (state, action) => {
      state.campaignDataTablePagination = {
        ...state.campaignDataTablePagination,
        campaignPageNumber: action?.payload,
      };
    },
    resetCampaignPaginationReducerState: () => {
      return initialState;
    },
  },
});

export const {
  setCampaignDataTablePagination,
  resetCampaignPaginationReducerState,
} = paginationSlice.actions;

export default paginationSlice.reducer;
